

import {Component, Vue} from 'vue-property-decorator'
import ModalAccept from "@/components/modal-accept/index.vue";
import Input from "@/components/input2/index.vue";
import user_module from "@/modules/user/index";

import Toasted from 'vue-toasted';
import Loader from "@/components/loader/Loader.vue";
import ShowPassword from "@/components/show-password/index.vue";
import {AccountData} from "@/modules/user/index.d";
import accountItems from "@/modules/user/account-items";
import DropdownClick from '@/components/dropdown/DropdownClick.vue';
import {DropdownClickItem} from '@/components/dropdown/index.d';
import Strengthmeter from '@/components/strengthmeter/index.vue';
import {checkPasswordStrength} from '@/lib/checkPasswordStrength'
import states from './states';

const toastOptions = {

  position: "top-left",
  duration: 3000,
  iconPack: "fontawesome",
  theme: "outline",
  type: "success",
  icon: "check"
}

Vue.use(Toasted, toastOptions)

interface AccountItem {
  name: string,
  title: string,
  required: boolean
}

@Component({
    components: {
      ModalAccept,
      Input,
      Loader,
      ShowPassword,
      DropdownClick,
      Strengthmeter
    }
})

export default class Register extends Vue {


  public states: DropdownClickItem[] = states;
  public accountItems: AccountItem[] = accountItems;

  public accountData: AccountData = {
    Email: "",
    Password: "",
    CompanyName: "",
    FirstName: "",
    LastName: "",
    Phone: "",
  }

  public repeatPassword: string = '';

  errors: any = {};

  invalidHeaderText: string = 'Invalid Access Details';
  invalidContentText: string = 'Wrong username/password or your account/account password has expired. Please check your credentials or contact us at 800-282-4567, clientsuccess@rixtrema.com';
  openedInvalidModal: boolean = false;
  loading: boolean = false;
  password_is_displayed: boolean = false;
  repeat_password_is_displayed: boolean = false;

  get didnotmatch(){

    const {Password} = this.accountData;

    return Password !== this.repeatPassword;
  }


  get passwordStrength(){

    return checkPasswordStrength(this.accountData['Password']);

}

  get repeatPasswordStrength(){

    return checkPasswordStrength(this.repeatPassword);
    
  }

  get productId(): string{
    let productId = this.$route.query.product;
    
    if (typeof productId === 'string'){

      productId = productId.toUpperCase();
      
    } else {

      productId = '';
    }
    
    return productId;

  }
  

  get source(): string{
    let source = this.$route.query.source;
    
    if (typeof source === 'string'){

      return source;
      
    } 
    
    return '';

  }

  get selectedState(){

    return this.accountData.State || '';

  }

  get product(){

    const product = user_module.userProducts.find(product => product.productCode === this.productId);

    if (product){

      return product.name;
    }


    return '';
  }

  get isMobile(){

    return user_module.isMobile;
  }

  get enabledRegister(){

    const emptyRequiredItem = this.accountItems.find((item: AccountItem) => {

      if (item.required){

        return !this.accountData[item.name];
      } 

      return false;

    });

    const error = Object.values(this.errors).findIndex(item => !item);

    return !emptyRequiredItem && error === -1 && this.accountData.Password && this.repeatPassword && this.passwordStrength && this.repeatPasswordStrength && !this.didnotmatch;
    
  }

  setError(name: string, v: any){

    this.errors = {...this.errors, [name]: v};

  }
  
  inputAccountItem(name: string, v: string){ 

    const exceptions = ['City', 'Address1', 'Address2'];

    let value = v;
    if (exceptions.indexOf(name) > -1){

      const newValue = v.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
      value = newValue;

    }

    this.accountData = {
      ...this.accountData,
      [name]: value
    }

  }

  preregister(){

    if (this.enabledRegister){

      const {Password} = this.accountData;

      if (Password !== this.repeatPassword){

        this.$toasted.error('Passwords do not match', {
          duration: 3000,
          icon: ''
        }); 

      } else if (Password.length < 8 || !/\d/.test(Password)){

        this.$toasted.error('Password must be minimum of 8 characters, with at least one number', {
          duration: 3000,
          icon: ''
        }); 

      } else {
        
        this.register()

      }
      
    }

  }

  async register(){

    this.loading = true;

    if (this.productId){
      this.accountData.product = this.productId;
    }

    if (this.source){
      this.accountData.Source = this.source;
    }

    const response = await user_module.register(this.accountData);

    console.log('response', response);

    if (response.result === 'Success'){

      this.$toasted.show(`<b>Success! Check you email</b>`, {
        duration: 3000
      })

      this.$router.push('/register-success');

    } else if (response.result === "Account with this email already exists, but not activated"){

      this.$toasted.info(`<b>Account with this email already exists, but not activated. Please, check your email</b>`, {
        duration: 8000
      })

    }  else {

      this.$toasted.error(response.data, {
        duration: 6000,
        icon: ''
      })

    }


    this.loading = false;

  }

  displayPassword() {

    this.password_is_displayed = !this.password_is_displayed

  }

  displayRepeatPassword() {

    this.repeat_password_is_displayed = !this.repeat_password_is_displayed

  }


  closeInvalidModal(){

    this.openedInvalidModal = false;
  }

  validateEmail(email: string) {

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());

  }

  saveState(newState){

    const state = this.states.find(state => state.id === newState.id);

    if (state){

      this.accountData = {
        ...this.accountData,
        State: state.id
      }

    }


  }

  beforeMount() {
    
    if (user_module.lastAccountData){

      this.accountData = user_module.lastAccountData;

    }
  }

}

